import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";
import Badge from "@mui/material/Badge";
import Tabs from "@mui/material/Tabs";

const StatusBar = ({
  dataSearch = {},
  setDataSearch = () => {},
  statusTabs = [],
  isSmallerThanTablet = false,
}) => {
  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        width: "100%",
        typography: "body1",
        mb: 2,
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Tabs
        value={dataSearch.status}
        onChange={(e, newValue) => {
          setDataSearch((prev) => ({
            ...prev,
            status: newValue,
            page: 0,
          }));
        }}
        variant="scrollable"
        scrollButtons={false}
        aria-label="scrollable prevent tabs"
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "#E13B30",
          },
          "& .MuiTab-root.Mui-selected .MuiTypography-root": {
            color: "#E13B30",
          },
          "& .MuiTab-root.Mui-selected .MuiBadge-root .MuiBadge-badge": {
            backgroundColor: "#E13B30",
          },
        }}
      >
        {statusTabs.map((tab, index) => (
          <Tab
            key={index}
            sx={{ overflow: "initial" }}
            label={
              <Stack direction="row" alignItems={"center"}>
                {tab.label !== "ทั้งหมด" && (
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      backgroundColor: tab.color,
                      marginRight: 1,
                    }}
                  />
                )}

                <Typography
                  sx={{
                    fontSize: isSmallerThanTablet ? "0.75rem" : "0.875rem",
                  }}
                >
                  {tab?.label}
                </Typography>
                <Badge
                  badgeContent={tab?.count}
                  sx={{
                    ml: 3,
                    "& .MuiBadge-badge": {
                      backgroundColor: "#BCBCC0",
                      color: "white",
                      fontSize: isSmallerThanTablet ? "0.625rem" : "0.75rem",
                      padding: "4px 8px",
                      borderRadius: "12px",
                    },
                  }}
                  showZero
                />
              </Stack>
            }
            value={tab?.value}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default StatusBar;
